export enum DealStep {
  CONTACTED = 'contacted',
  AWAITING_MATCH_VALIDATION = 'awaiting_match_validation',
  IN_PROGRESS = 'in_progress',
  SCHEDULE_PROPOSAL = 'schedule_proposal',
  CONTACTED_BUYER = 'contacted_buyer',
  CONTACTED_SELLER = 'contacted_seller',
  SCHEDULE_PROPOSAL_BUYER = 'schedule_proposal_buyer',
  SCHEDULE_PROPOSAL_SELLER = 'schedule_proposal_seller',
  VISIT_CONFIRMED = 'visit_confirmed',
  AFTER_VISIT_FEEDBACK_SENT = 'visit_passed_feedback_sent',
  AFTER_VISIT_SUMMARY_SENT = 'visit_passed_summary_sent',
  AFTER_VISIT = 'visit_passed',
  SIGNED = 'signed',
  UNSIGNED = 'unsigned',
  UNSIGNED_BEFORE_VISIT = 'unsigned_before_visit',
  UNSIGNED_AFTER_VISIT = 'unsigned_after_visit',
  VISIT_TODAY = 'visit_today',
}

export enum DealState {
  CONTACTED = 'contacted',
  AWAITING_MATCH_VALIDATION = 'awaiting_match_validation',
  IN_PROGRESS = 'in_progress',
  SIGNED = 'signed',
  UNSIGNED = 'unsigned',
}
